import {useEffect} from 'react'
import {loadModules, setDefaultOptions} from 'esri-loader'
import ArcGIS from 'terraformer-arcgis-parser'
import Terraformer from 'terraformer'
import WKT from 'terraformer-wkt-parser'
const MapAddEnterprise = (props: any) => {

  setDefaultOptions({css: true})
  const styles = {
    container: {
      height: '70vh',
    },
    mapDiv: {
      height: '69vh',
      border: '3px solid #ccc',
      background: '#ccc',
      borderRadius: '10px',
    },
  }

  useEffect(() => {
    loadModules([
      "esri/widgets/Sketch",
      "esri/Map",
      "esri/layers/GraphicsLayer",
      "esri/views/MapView",
      "esri/geometry/Extent",
      "esri/geometry/SpatialReference",
      "esri/Graphic",
      "esri/geometry/Point",
      "esri/geometry/Polyline",
      "esri/geometry/Polygon",
      "esri/geometry/geometryEngine"
    ])
      .then(([Sketch, Map, GraphicsLayer, MapView, Extent, SpatialReference, Graphic, Point, Polyline, Polygon, geometryEngine]) => {
        
        let layer = new GraphicsLayer({});
        
        // criação do mapa
        const map = new Map({
          basemap: 'hybrid',
          layers: [layer],
        })

        // criação da view
        const view = new MapView({
          container: 'viewDiv',
          map: map,
          zoom: 4,
          center: [0, 0],
        })

        let startExtent = new Extent({
            xmin: -73.9872354804,
            ymin: -33.7683777809,
            xmax: -34.7299934555,
            ymax: 5.24448639569,
            spatialReference: new SpatialReference({ wkid:4326 })
        });

        view.extent = startExtent;


        const sketch = new Sketch({
            layer: layer,
            view: view,
            creationMode: "update",
            availableCreateTools: ["point", "polyline", "polygon"],
            defaultUpdateOptions: {
                enableRotation: false,
                enableScaling: false,
                multipleSelectionEnabled: false,
                toggleToolOnClick: false,
                tool: "reshape"
            },
        });

        sketch.on("create", function(event: { state: string }) {
          if (event.state === "complete") {
              sketch.availableCreateTools = [];
              
              let geomOject = layer.graphics.items[0];
              let geomtype = geomOject.geometry.type;

              let geojson = ArcGIS.parse(geomOject.geometry);
              Terraformer.Tools.toGeographic(geojson);
              let geomWKT = WKT.convert(geojson);

              if(geomtype == "polyline")
                geomtype = "line";

              props.setGeometryType(geomtype);
              props.setGeomPoint(null);
              props.setGeomLine(null);
              props.setGeomPolygon(null);

              switch(geomtype){
                case "point":
                    props.setGeomPoint(geomWKT);
                    break;
                case "line":
                    props.setGeomLine(geomWKT);
                    break;
                case "polygon":
                    props.setGeomPolygon(geomWKT);
                    break;
              }
            }
        });

        sketch.on("update", function(event: { toolEventInfo: { type: string | string[] }; graphics: { geometry: { type: string } }[] }) {
            if (event.toolEventInfo && event.toolEventInfo.type.includes("move") && event.graphics[0].geometry.type != "point"){
                sketch.cancel();
            }
        });

        view.ui.add(sketch, "top-right");

        sketch.on("delete", function(event: any) {
          sketch.availableCreateTools = ["point", "polyline", "polygon"];
          props.setGeometryType(null);
          props.setGeomPoint(null);
          props.setGeomLine(null);
          props.setGeomPolygon(null);
        });

      })

      .catch((err) => console.error(err))
    //eslint-disable-next-line
  }, [props.longitude, props.latitude, props.name, props.description, props.zoom, props.duration, props.setGeomPoint, props.setGeomLine, props.setGeomPolygon, props.setGeometryType])

  return (
    <div style={styles.container}>
      <div id='viewDiv' style={styles.mapDiv}></div>{' '}
    </div>
  )
}

export {MapAddEnterprise}